import { orderDetailsApi } from '@app/store/reducers/salaryCards/orderDetails.api'
import ButtonGlobal from '@shared/Button'
import { useCustomModal } from '@shared/Modal'
import { Col, Row } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { t } from 'i18next'
import { DeleteOrderRequestData } from 'pages/Orders/types'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useFetchDeleteSalaryCardOrderMutation } from 'store/reducers/salaryCards/salaryCardList.api'

export default function DeleteOrderForm({ orderNo }: { orderNo: string }) {
  const dispatch = useDispatch()

  const { control, getValues } = useForm({
    defaultValues: {
      deleteReason: '',
    },
  })

  const { closeModal, setStatus, open } = useCustomModal()

  const [
    fetchDeleteSalaryCardOrder,
    { isSuccess, status: deletedStatus, error, isError },
  ] = useFetchDeleteSalaryCardOrderMutation()

  const deleteRow = () => {
    const requestData: DeleteOrderRequestData = {
      orderNo,
      description: getValues('deleteReason'),
    }
    fetchDeleteSalaryCardOrder(requestData)
  }

  useEffect(() => {
    setStatus({
      status: deletedStatus,
      message: isError
        ? (error?.data as string)
        : 'Əməliyyat uğurla icra olundu',
    })
  }, [deletedStatus, isSuccess])

  useEffect(() => {
    if (isSuccess && !open) {
      dispatch(
        orderDetailsApi.endpoints.fetchOrderDetails.initiate(
          { orderNo },
          { fixedCacheKey: 'fetchOrderDetails' }
        )
      )
    }
  }, [open])

  return (
    <Row style={{ flexDirection: 'column' }}>
      <Col span={24}>
        <label> {t('newTransfer.note')}</label>
        <Controller
          name="deleteReason"
          control={control}
          render={({ field }) => (
            <TextArea
              showCount
              maxLength={300}
              {...field}
              style={{ height: '80px !important', resize: 'none' }}
            />
          )}
        />
      </Col>
      <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonGlobal
          customType="primary"
          style={{ marginRight: '15px' }}
          onClick={deleteRow}
        >
          {t('home.yes')}
        </ButtonGlobal>
        <ButtonGlobal customType="default" onClick={closeModal} color="#015CD1">
          {t('home.no')}
        </ButtonGlobal>
      </Col>
    </Row>
  )
}
